import type { PlainDateString } from "@sa-nu/shared-utils/date";
import { PlainDate, parsePlainDate } from "@sa-nu/shared-utils/date";

import type { CICOSelection } from "../reservation-calendar";

/** CI〜CO-1（宿泊日）に該当するか判定 */
export function isCICOStayNight(
  date: PlainDate | PlainDateString,
  cico: CICOSelection | null,
): boolean {
  if (!cico) return false;
  const d = typeof date === "string" ? parsePlainDate(date) : date;
  return (
    PlainDate.compare(d, cico.checkIn) >= 0 &&
    PlainDate.compare(d, cico.checkOut) < 0
  );
}
